<div *ngIf="error" class="tp-error m-b-1">{{ error }}</div>

<section class="assignment-card">
  <div class="assignment-card__header">
    <div class="assignment-card__cell assignment-card__cell--name">
      {{ label }}
      <sup *ngIf="required">*</sup>

      <tp-icon
        *ngIf="tooltipText"
        class="assignment-card__tip-icon m-l-1"
        [tpTooltip]="tooltipText"
        name="icons/help"
      ></tp-icon>
    </div>

    <div class="assignment-card__cell">
      <mat-checkbox
        class="m-r-1"
        (change)="toggleSelectAll($event)"
        [checked]="isAllSelected"
      ></mat-checkbox>

      <span class="hide-on-mobile">Select All</span>
      <span class="show-on-mobile">All</span>
    </div>
  </div>

  <div class="assignment-body">
    <div *ngFor="let item of items" class="assignment-card__row">
      <div class="assignment-card__cell assignment-card__cell--name">
        {{ item.name }}
      </div>

      <div class="assignment-card__cell">
        <mat-checkbox
          (change)="itemSelectionChange($event, item.id)"
          [checked]="selectedIds.includes(item.id)"
        ></mat-checkbox>
      </div>
    </div>
  </div>
</section>
